export const bemClasses = Object.freeze({
    LIGHT: 'light',
    DARK: 'dark',
    NTT: 'ntt'
});
